import { fetchJson } from '@xingternal/malt-network';
import { config } from '@xingternal/hops';

import camelcaseKeys from './camelcaseKeys';
import snakecaseKeys from './snakecaseKeys';
import toQueryString from './toQueryString';

const doFetch = async (endpoint, payload) =>
  fetchJson(`/xhr${endpoint}`, payload);

const api = {};
const jsonHeaders = {
  'Content-Type': 'application/json; charset=utf-8',
  Accept: 'application/json',
};

api.get = async (endpoint, payload) => {
  let uri = endpoint;

  if (payload) {
    const searchString = '?' + toQueryString(snakecaseKeys(payload));
    uri = uri + searchString;
  }

  const options = {
    method: 'GET',
    headers: jsonHeaders,
  };

  try {
    const response = await doFetch(uri, options);
    return camelcaseKeys(response);
  } catch (err) {
    const { success, error, target } = err.jsonResponse;

    if (!success && error === 'FULLY_LOGGED_IN') {
      window.location.href = target || config.externalUrl;
    }

    throw err;
  }
};

api.post = async (endpoint, payload) => {
  const body = payload && JSON.stringify(snakecaseKeys(payload));
  const options = {
    method: 'POST',
    headers: jsonHeaders,
    body,
  };

  try {
    const response = await doFetch(endpoint, options);
    return camelcaseKeys(response);
  } catch (err) {
    throw err;
  }
};

api.postMultiPart = async (endpoint, formData) => {
  const body = formData;

  const options = {
    method: 'POST',
    body,
  };

  try {
    const response = await doFetch(endpoint, options);
    return camelcaseKeys(response);
  } catch (err) {
    throw err;
  }
};

api.postRetry = async (endpoint, payload, retries = 2) => {
  try {
    const result = await api.post(endpoint, payload);
    return result;
  } catch (err) {
    if (retries === 1) throw err;

    // skip retry for wrong credentials
    const status = err.response && err.response.status;
    if (status <= 401) throw err;

    const result = await api.postRetry(endpoint, payload, retries - 1);
    return result;
  }
};

export default api;
